module.exports = __webpack_public_path__ + "img/price-square-meter-2.f65731e2.jpg";